import { useContext } from 'react'
import { ModalContext } from '../context/modal-context'

export const useModal = () => {
	const { dispatch: dispatchModal } = useContext(ModalContext)

	const showModal = modal => {
		dispatchModal({ type: 'set-modal', modalActive: modal })
	}

	const clearModal = () => {
		dispatchModal({ type: 'clear-modal' })
	}

	const showErrorModal = modal => {
		dispatchModal({ type: 'set-error-modal', errorModal: modal })
	}

	const clearErrorModal = () => {
		dispatchModal({ type: 'clear-error-modal' })
	}

	return {
		showModal,
		clearModal,
		showErrorModal,
		clearErrorModal,
	}
}
